const TYPES = {
    ROUTES: {
     DOCS: 'https://docs.integrationos.com',
     NPM: 'https://www.npmjs.com/package/@integrationos/authkit'
    }
 }
 
 export default TYPES